
import XButton from 'vux/src/components/x-button/index.vue'

import { redAnswer, myPacket } from "@/api/ajax.js";
import { mapState } from "vuex";
import { marquee } from "@/Mixin/marquee.js";

export default {
name: "correct",
mixins: [marquee],
data() {
return {
bestToday: [],
scoreAmount: 0,
myAnswerAmount: {},
};
},
methods: {
toast() {
sa.track(
"activity",
{
action: "vzb_dati2018",
type: "share",
},
function () {}
);

this.$sa.re_activity({
name: "答题拼图",
event_type: "点击分享",
});

this.$vux.toast.show({
text: "点击右上角，分享给微信好友吧",
type: "text",
width: "7rem",
});
},
toMyredpacket() {

this.$router.push({
name: "myredpacket",
});
},
},
computed: {
...mapState({
wxUserInfo: (state) => state.wxUserInfo,
}),
},
components: {
XButton,
},
beforeRouteEnter(to, from, next) {
console.log(from);
next();
},
created() {
setTimeout(() => {
if (!this.$route.query.first) {
this.$vux.toast.show({
text: "每天仅有一次答题机会,明天再来参加吧",
type: "text",
width: "7rem",
});
}
}, 1000);
redAnswer.bestToday().then((res) => {
this.bestToday = res.data.data;







});
myPacket.myAnswerAmount().then((res) => {
this.myAnswerAmount = res.data;

if (!this.myAnswerAmount.todayAmount) return false;
let shareUrl = `${this.$config.javaPath}/html/answerGold/index210505.html#/share/${this.myAnswerAmount.redPackId}?shareFlag=true`;
this.$wxShareInfo(
"你领或不领，红包就在那里，不离不弃~",
"但手速慢，被别人抢，可不能怪我没提醒",
"http://cdn.yxvzb.com/html/AnswerGold/share2.png",
location.href.split("#")[0],
shareUrl,
""
);
});
},
beforeRouteLeave(to, from, next) {
if (to.name == "play") {
next({
name: "home",
});
} else {
next(true);
}
},
};



// WEBPACK FOOTER //
// ./src/page/CorrectEntry/index.vue